import React from 'react';
import PropTypes from 'prop-types';
import { Tag as AntTag } from 'antd';
import { useTheme } from '../../../contexts/ThemeContext';

const Tag = ({ children, color, style, icon, closable, onClose, ...props }) => {
  const { theme } = useTheme();

  const getColorStyle = (tagColor) => {
    if (!tagColor) {
      return {
        backgroundColor: theme.backgroundLight,
        color: theme.textSecondary,
        borderColor: theme.borderColor,
      };
    }

    // Cores predefinidas com fundo colorido e texto branco
    const colorMap = {
      success: { bg: '#52c41a', color: '#ffffff', border: '#52c41a' },
      error: { bg: '#ff4d4f', color: '#ffffff', border: '#ff4d4f' },
      warning: { bg: '#faad14', color: '#ffffff', border: '#faad14' },
      info: { bg: '#1890ff', color: '#ffffff', border: '#1890ff' },
      blue: { bg: '#1890ff', color: '#ffffff', border: '#1890ff' },
      green: { bg: '#52c41a', color: '#ffffff', border: '#52c41a' },
      red: { bg: '#ff4d4f', color: '#ffffff', border: '#ff4d4f' },
      orange: { bg: '#fa8c16', color: '#ffffff', border: '#fa8c16' },
      purple: { bg: '#722ed1', color: '#ffffff', border: '#722ed1' },
      cyan: { bg: '#13c2c2', color: '#ffffff', border: '#13c2c2' },
      gold: { bg: '#fadb14', color: '#ffffff', border: '#fadb14' },
      geekblue: { bg: '#2f54eb', color: '#ffffff', border: '#2f54eb' },
    };

    return colorMap[tagColor] || {
      backgroundColor: theme.backgroundLight,
      color: theme.textSecondary,
      borderColor: theme.borderColor,
    };
  };

  const colorStyle = getColorStyle(color);
  const tagStyle = {
    transition: 'all 0.3s ease',
    backgroundColor: colorStyle.bg,
    color: colorStyle.color,
    borderColor: colorStyle.border,
    ...style,
  };

  return (
    <AntTag
      style={tagStyle}
      icon={icon}
      closable={closable}
      onClose={onClose}
      {...props}
    >
      {children}
    </AntTag>
  );
};

Tag.propTypes = {
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
  style: PropTypes.object,
  icon: PropTypes.node,
  closable: PropTypes.bool,
  onClose: PropTypes.func,
};

export default Tag; 